import { ForgotPasswordForm } from "@/routes/auth/_auth-layout/-components/auth/forgot-password.form";
import { FORGOT_PASSWORD_ERROR_RAW } from "@/lib/utils";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4";
import { zodValidator } from "@tanstack/zod-adapter";
import { AuthCard } from "@/routes/auth/_auth-layout/-components/auth/auth-card";

const searchParamsSchema = z.object({
  error: FORGOT_PASSWORD_ERROR_RAW.optional(),
});

export const Route = createFileRoute("/auth/_auth-layout/forgot-password")({
  validateSearch: zodValidator(searchParamsSchema),
  component: () => <ForgotPassword />,
});

function ForgotPassword() {
  const search = Route.useSearch();
  const isExpiredError = search.error === "EXPIRED";

  return (
    <AuthCard
      backTo="/auth/signin"
      title={
        isExpiredError ? "Password reset link expired" : "Forgot your password?"
      }
      description={
        isExpiredError
          ? "Please request a new password reset email."
          : "Enter your email address to receive a reset link. If you do not receive an email, please check your spam folder."
      }
      footer="Password reset links expire for security."
    >
      <ForgotPasswordForm />
    </AuthCard>
  );
}
